import {useState, useCallback} from 'react'
import {EditorTheme} from './types'

const STORAGE_KEY = '__obvio_editor_custom_theme_mode__'

function getStoredTheme(): EditorTheme {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'Light' || stored === 'Dark' || stored === 'Auto') {
      return stored
    }
  } catch {
    // localStorage not available
  }
  return 'Auto'
}

export default function useEditorTheme() {
  const [theme, setThemeState] = useState<EditorTheme>(getStoredTheme)

  const setTheme = useCallback((newTheme: EditorTheme) => {
    setThemeState(newTheme)
    try {
      localStorage.setItem(STORAGE_KEY, newTheme)
    } catch {
      // localStorage not available
    }
  }, [])

  return {theme, setTheme}
}
